module.exports = __webpack_public_path__ + "img/icon-use-01.svg";